import { useTasksStore } from '../../stores/tasks';
import { useAuthStore } from '../../stores/auth';
import ContentWrapper from '../layout/ContentWrapper';
import { TaskDetailBody } from './TaskDetailBody';
import { groupTasks } from './taskGroups';

// Mobile fullscreen view of a single task (merged across assignees).
export default function TaskDetailScreen({ taskId, onBack }: { taskId: string; onBack: () => void }) {
  const tasks = useTasksStore((s) => s.tasks);
  const currentUserId = useAuthStore((s) => s.user?.id) ?? '';
  const group = groupTasks(tasks).find((g) => g.tasks.some((t) => t.id === taskId));

  return (
    <ContentWrapper title="Task" onBack={onBack}>
      <div style={{ flex: 1, overflowY: 'auto', background: 'var(--surface-app)' }}>
        {group ? (
          <>
            <div style={{
              padding: '14px 16px 12px', fontSize: '1rem', fontWeight: 700,
              color: 'var(--text)', overflowWrap: 'anywhere',
            }}>
              {group.representative.title}
            </div>
            <TaskDetailBody group={group} currentUserId={currentUserId} onClose={onBack} />
          </>
        ) : (
          <div style={{ color: 'var(--shell-xs)', textAlign: 'center', paddingTop: 48, fontSize: '0.82rem' }}>
            This task is no longer available
          </div>
        )}
      </div>
    </ContentWrapper>
  );
}
